'use strict';

function DonutChart() {
  this.extends = [_ComponentDataBind, _ResponsiveLayout];
  this.declaredClass = null;
  this.node = null;
  this.id = null;
  this.duration = 1200;
  this.startValue = [0, 0]; // Default value(s) 0;
  this.points = 2;
  this.path = [];
  this.centerdial = true;
  this.percentages;
  this.holdingsArray;

  this.init = function () {
    this._super();

    this.$node = $(this.node);
    this.$percent = this.$node.find('.three-part-dial__percent-container');

    // set initial values
    this.$node.attr('role', 'progressbar');
    this.$node.attr('aria-valuemin', 0);
    this.$node.attr('aria-valuemax', 100);

    // create the dial
    this._createDialSVG();
    this.$node.show();

    this.onDataBindUpdate('percentages', this._updateDials.bind(this));
  };

  this.initAllReady = function () {
    this._super();
  };

  this.destroy = function () {
    this._super();
  };

  this._createDialSVG = function () {
    var dial = void 0;
    var points = this._calculatePoints();
    var basePath = '<path class="basePath" d="M 0,0m 25, 100a 75,75 0 1,0 150,0a 75,75 0 1,0 -150,0"></path>';
    var pathOne = '<path class="pathOne" d="M 0,0m 25, 100a 75,75 0 1,0 150,0a 75,75 0 1,0 -150,0" transform="rotate(' + points[0] + ' 100 100)"></path>';
    var pathTwo = this.points > 1 ? '<path class="pathTwo" d="M 0,0m 25, 100a 75,75 0 1,1 150,0a 75,75 0 1,1 -150,0" transform="rotate(' + points[1] + ' 100 100)"></path>' : '';
    var middleCircle = '<path class="middleCircle" d="M 0,0m 25, 100a 75,75 0 1,0 150,0a 75,75 0 1,0 -150,0" transform="translate(15 15) scale(.85 .85)"></path>';
    var innerCircle = '<path class="innerCircle" d="M 0,0m 25, 100a 75,75 0 1,0 150,0a 75,75 0 1,0 -150,0" transform="translate(52 52) scale(.48 .48)""></path>';
    if (this.centerDial) {
      dial = basePath + pathOne + pathTwo + middleCircle + innerCircle;
    } else {
      dial = basePath + pathOne + pathTwo;
    }
    var svg = $('<svg viewBox="15 10 170 170"><g>' + dial + '</g></svg>');
    svg.attr('class', 'three-part-dial__percent-svg');
    this.path[0] = svg.find('path').eq(1);
    this.path[1] = svg.find('path').eq(2);
    this.$percent.append(svg);
  };

  this._calculatePoints = function () {
    var base = 90;
    var increment = 5;
    if (this.points === 1) {
      return [base];
    }
    if (this.points === 2) {
      var points = [base - increment, base + increment];
      return points;
    }
  };

  this._updateDials = function () {
    this.holdingsArray = JSON.parse('[' + this.percentages + ']');
    this.$node.attr('aria-valuefirst', this.holdingsArray[0]);
    this.$node.attr('aria-valuesecond', this.holdingsArray[1]);
    this._animatePath(0); // index
    this._animatePath(1); // index
  };

  this._animatePath = function (index) {
    // Animate when the percentages values change, else donut stays the same
    if (this.startValue[index] !== this.holdingsArray[index]) {
      $({ value: this.startValue[index], points: this.points, path: this.path, index: index }).animate({ value: this.holdingsArray[index] }, {
        queue: false,
        easing: 'easeOutCubic',
        duration: this.duration,
        step: function step(value) {
          // "this" inside step function is scoped
          // min range 755 // max range 315 // working range 440 // multi-point padding 30
          var range = 440 * value;
          var barProgress = 755 - range;
          if (range) barProgress -= 1;
          if (this.points <= 1 && value > 0) barProgress -= 30; // remove extra padding if only one point graphed
          this.path[index].css({
            'stroke-dashoffset': barProgress
          });
          // Augment animate promise with endProgress percentage
          this.endProgress = value;
        },

        done: function (promise) {
          // Use Done because it returns a promise
          var el = promise;
          // Hoist the Value from the Step function
          this.startValue[el.elem.index] = el.elem.endProgress ? el.elem.endProgress : 0;
        }.bind(this)
      });
    }
  };
}